module.exports = __webpack_public_path__ + "img/png_tszp_4@2x.4b59b72c.png";